module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-modal', {
    staticClass: "custom-modal",
    attrs: {
      "visible": _vm.isTipShow,
      "closable": false,
      "mask-closable": false,
      "destroy-after-close": true,
      "center": true,
      "title": "服务协议"
    }
  }, [_c('div', {
    staticClass: "message"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("为确保您已知晓360分析及您相关权益条款，还请阅读"), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://s4.ssl.qhres.com/static/68681a638322a648.pdf",
      "target": "_blank"
    }
  }, [_vm._v("360服务协议")]), _vm._v("并点击 “确认” 表明同意该服务协议")]), _c('button', {
    staticClass: "btn btn-primary btn-small btn-mgr",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("确认")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d7ef603", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d7ef603!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/privacyModal.vue
// module id = 709
// module chunks = 0